import React from 'react';

const PageError = () => {
    return (
        <div className='container min-h-50 py-20 d-flex'>
            <div className="m-auto text-center">
                <h1 className='display-1'>Oops!</h1>
                <h1>Something went wrong. Please contact administrator.</h1>
            </div>
        </div>
    );
}

export default PageError;
